import * as React from "react";
import {
  Offer,
  ExperienceContext,
  getAllOffers,
  getFirstOffer,
} from "@origin-digital/features";

interface IUpdate {
  labelA: string;
  labelB: string;
  insertOrUpdate?: "update";
  href?: string;
}
interface IInsert {
  labelA: string;
  labelB: string;
  insertOrUpdate: "insert";
  href: string;
}

export interface ABTestDropDownMenu {
  label: string;
  menuItems: (IUpdate | IInsert)[];
}

interface INavMenuItem {
  desktopOnly?: boolean;
  label: string;
  href?: string;
  icon?: string;
  onClick?: () => void;
}

interface INavbarDropdown {
  label: {
    text: string;
    icon: string;
    smallIcon?: boolean;
  };
  menuItems: INavMenuItem[];
}

export interface ExtendedExperienceSelectorProps {
  children: (payload?: any, data?: unknown) => React.ReactNode;
  mboxes: string[];
  multipleOffers?: boolean; // By default, ExperienceSeletor calls children with only the first offer
}

export const ExtendedExperienceSelector: React.FunctionComponent<
  ExtendedExperienceSelectorProps
> = ({ children, mboxes, multipleOffers = false }) => (
  <ExperienceContext.Consumer>
    {({ targetOffers, loading }) => {
      const content = mboxes.flatMap((mbox) => {
        const mboxOffer = targetOffers.find(
          (offer: Offer) => offer.mbox === mbox
        );
        return multipleOffers
          ? getAllOffers(mboxOffer)
          : getFirstOffer(mboxOffer);
      });
      console.log(content);

      return children(content, { loading });
    }}
  </ExperienceContext.Consumer>
);

export function updateNavStructure(
  content: ABTestDropDownMenu[],
  navStructure: INavbarDropdown[]
) {
  if (!content || !Array.isArray(content)) {
    return navStructure;
  }

  const labelMenuItemMap = content.reduce((labelMenuItemAcc, currentValue) => {
    if (currentValue.label) {
      if (currentValue.label in labelMenuItemAcc) {
        labelMenuItemAcc[currentValue.label].push(...currentValue.menuItems);
      } else {
        labelMenuItemAcc[currentValue.label] = currentValue.menuItems;
      }
    }

    return labelMenuItemAcc;
  }, {});

  return navStructure.reduce((newNavStructureAcc, currentNav) => {
    const testMenuItems = labelMenuItemMap[currentNav.label.text];
    if (testMenuItems) {
      const { label, menuItems: currentNavMenuItems } = currentNav;

      const updatedMenuItems = currentNavMenuItems.reduce(
        (menuItemsAcc, menuItemsCurrentVal) => {
          const menuItemToBeChanged = testMenuItems.filter(
            (testMenuItem) => testMenuItem.labelA === menuItemsCurrentVal.label
          );

          if (menuItemToBeChanged.length === 0) {
            menuItemsAcc.push(menuItemsCurrentVal);
          } else {
            // Insert new menu item
            // eslint-disable-next-line no-lonely-if
            if (menuItemToBeChanged[0].insertOrUpdate === "insert") {
              menuItemsAcc.push(menuItemsCurrentVal);
              menuItemsAcc.push({
                label: menuItemToBeChanged[0].labelB,
                href: menuItemToBeChanged[0].href,
              });
            } else if (menuItemToBeChanged[0].labelB) {
              // Update the existing menu item
              menuItemsAcc.push({
                ...menuItemsCurrentVal,
                label: menuItemToBeChanged[0].labelB,
                ...(menuItemToBeChanged[0].href
                  ? { href: menuItemToBeChanged[0].href }
                  : undefined),
              });
            }
          }

          return menuItemsAcc;
        },
        [] as INavMenuItem[]
      );
      newNavStructureAcc.push({ label, menuItems: updatedMenuItems });
    } else {
      newNavStructureAcc.push(currentNav);
    }

    return newNavStructureAcc;
  }, [] as INavbarDropdown[]);
}
